export const EVENT_TYPES = {
  CBP: "cbp",
  IMPACT_FEST: "impact_fest",
};

export const EVENT_DISPLAY_NAMES = {
  [EVENT_TYPES.CBP]: "Capacity Building Program",
  [EVENT_TYPES.IMPACT_FEST]: "AI India Impact Festival",
};
